module.exports = __webpack_public_path__ + "static/media/1morecoin.0dcc3476.png";